/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Slide2description1Inputs */

const he_extension_slide2description1 = /** @type {(inputs: Extension_Slide2description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיר גבוה, נמוך וממוצע עם ניתוח מגמות`)
};

const en_extension_slide2description1 = /** @type {(inputs: Extension_Slide2description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High, low, and average prices with trend analysis`)
};

/**
* | output |
* | --- |
* | "High, low, and average prices with trend analysis" |
*
* @param {Extension_Slide2description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_slide2description1 = /** @type {((inputs?: Extension_Slide2description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Slide2description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_slide2description1(inputs)
	return en_extension_slide2description1(inputs)
});
export { extension_slide2description1 as "extension_slide2Description" }